import { motion } from "framer-motion";
import { ReactNode } from "react";

interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  background?: "default" | "dark" | "gradient" | "transparent";
  padding?: "sm" | "md" | "lg" | "xl";
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "4xl" | "6xl" | "7xl";
  id?: string;
  animation?: {
    initial?: any;
    whileInView?: any;
    transition?: any;
  };
}

const SectionWrapper = ({
  children,
  className = "",
  background = "default",
  padding = "lg",
  maxWidth = "7xl",
  id,
  animation = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  }
}: SectionWrapperProps) => {
  const backgroundClasses = {
    default: "bg-slate-900",
    dark: "bg-slate-800/50",
    gradient: "bg-gradient-to-r from-teal-400 to-blue-500",
    transparent: "bg-transparent"
  };

  const paddingClasses = {
    sm: "py-8 px-4 sm:px-6 lg:px-8",
    md: "py-12 px-4 sm:px-6 lg:px-8",
    lg: "py-16 px-4 sm:px-6 lg:px-8",
    xl: "py-20 px-4 sm:px-6 lg:px-8"
  };

  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "4xl": "max-w-4xl",
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl"
  };

  const sectionClasses = `
    ${backgroundClasses[background]}
    ${paddingClasses[padding]}
    ${className}
  `.trim();

  return (
    <motion.section
      id={id}
      className={sectionClasses}
      initial={animation.initial}
      whileInView={animation.whileInView}
      transition={animation.transition}
      viewport={{ once: true }}
    >
      <div className={`${maxWidthClasses[maxWidth]} mx-auto`}>
        {children}
      </div>
    </motion.section>
  );
};

export default SectionWrapper;
